<script>
    // @ts-nocheck
    import { Typography, Chip } from '.'
    import List from './List.svelte'
    import PopOver from './PopOver.svelte'
    import { clickOutside, stringSimilarity } from '$lib/utils'
    import ScrollBox from './ScrollBox.svelte'
    import {
        getContext,
        onDestroy,
        createEventDispatcher,
        beforeUpdate,
        tick,
    } from 'svelte'
    import slide from '../../custom/animations/slide'
    import { ChevronDown, InfoOutline } from '../Icons'
    import { latLng } from 'leaflet'
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    //   export let name = null
    export let style = ''
    export let valid = null
    export let placeholder = ''
    export let options = []
    export let info = null
    export let overline = true
    export let searchable = true
    export let option
    //   export let currentIndex = null
    let open = false
    let options_ = !(options instanceof Promise) ? options : []
    let currentOptions = options_
    let inp
    let focusElement
    //   import createDataStore from '../../stores/datastore'
    //   let formData = getContext("formData")
    let display
    let inpFocus

    function keyActions(event) {
        open = true
        switch (event.key) {
            case 'Escape':
                if (open) open = false
                break
            case 'Enter':
                if (focusElement) {
                    option = focusElement
                    display = option.label
                    open = false
                }
                break
        }
    }

    function refreshSearch(e = null) {
        let tmpval = e ? e.target.value : e
        if (e && tmpval !== null && tmpval !== '') {
            let search = options_.filter((o) =>
                `${o.label} ${o.value}`.match(
                    new RegExp(tmpval + '|' + tmpval.split(' ').join('|'), 'i')
                )
            )
            search.sort((a, b) => {
                return stringSimilarity(tmpval, a.label) >
                    stringSimilarity(tmpval, b.label)
                    ? -1
                    : 1
            })
            currentOptions = search
        } else {
            currentOptions = options_
        }
    }

    function getOption(val, listOptions = null) {
        listOptions = listOptions ?? options_
        // console.log({listOptions})
        let match = listOptions
            ? listOptions?.find((x) => x.value === val)
            : undefined
        return match
    }

    beforeUpdate(async () => {
        await tick()
        let tmpVal = option ? option?.value || undefined : undefined
        if (value !== tmpVal) {
            // console.log(`${value} !== ${tmpVal}`)
            let tmpOption = getOption(value)
            if (tmpOption) {
                option = tmpOption
            } else {
                option = undefined
                // value = undefined
            }
            if(!option && !inpFocus) {
                console.log('display cleaned')
                display = ''
            }
            if (option && option.label !== display) display = option.label
        }
        // if(options instanceof Array && JSON.stringify(options_) !== JSON.stringify(options)) {
        //     options_ = options
        // }
    })

    $: if (option) value = option.value

    $: if (options_ && option) {
        option = getOption(option.value, options_)
    }

    $: if (options instanceof Promise) {
        let initialDisable = disabled
        if (!disabled) disabled = true
        options.then((r) => {
            options_ = r
            currentOptions = r
            disabled = false
            if (!initialDisable) disabled = false
        })
    } else if (options instanceof Array) {
        options_ = options
    }

    $: if (options_ && option) {
        let match = getOption(option.value, options_)
        // console.log('Nuevo diccionario', {opt: option.value, match, options_})
        if (match) {
            option = match
        } else {
            option = undefined
        }
    }

    $: if (option && option.label !== display && !inpFocus) {
        display = option.label
    }

    $: if (open === true && searchable) {
        inp.focus()
    }
    $: valid = validation ? validation(value) : true

    // $: console.log({option, display, searchable})
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div
    {style}
    class="box"
    class:disabled
    on:mouseover={(_) => (focus = true)}
    on:mouseout={(_) => (focus = false)}
    on:focus={(_) => (focus = true)}
    >
    <!-- <div class="ft"></div> -->
    <!-- on:blur={(_) => (focus = false)} -->
    {#if label}
        <div
            style="position: relative; display: flex; gap: 7px; align-items: center; margin-bottom: 16px"
        >
            <Typography
                style="margin: 0;"
                type="caption"
                color={disabled ? 'grey-300' : 'black'}>{label}</Typography
            >
            {#if required && !disabled && !value}
                <InfoOutline
                    size={16}
                    style="cursor: pointer"
                    title="Campo requerido."
                />
            {/if}
        </div>
    {/if}
    <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
    <!-- on:clickout={(_) => {open = false}} -->
    <div
        tabindex="0"
        on:blur={(_) => (focus = false)}
        on:focus={(_) => (focus = true)}
        on:keyup={(e) => {
            keyActions(e)
        }}
        style="position: relative; display: flex; cursor: pointer; gap: 12px; justify-content: space-between; align-items: center; width: 100%"
    >
        <PopOver
            style="width: 100%"
            --spacing="0px"
            transition={{ func: slide, duration: 200, delay: 0 }}
            position="bottom"
            bind:open
        >
            <svelte:fragment slot="select">
                <div
                    style="display: flex; flex-direction: columns; margin: 0; padding:0"
                >
                    <span
                        style="display: flex; gap: 5px; flex-wrap: wrap; padding: 0 0 2px 0"
                    >
                        <input
                            type="text"
                            disabled={disabled}
                            {placeholder}
                            bind:value={display}
                            bind:this={inp}
                            readonly={!searchable}
                            on:focus={() => {
                                if (!disabled) {
                                    currentOptions = options_
                                    inpFocus = true
                                    // open = true
                                }
                            }}
                            on:keyup={(e) => {
                                if (!disabled && searchable) {
                                    open = true
                                    refreshSearch(e)
                                }
                            }}
                            autocomplete="off"
                            on:blur={() => {
                                inpFocus = false
                                display = option ? option?.label || '' : ''
                            }}
                        />
                    </span>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <i>
                        <ChevronDown
                            color={disabled || currentOptions.length == 0
                                ? '#CCCCCC'
                                : '#6F7072'}
                        />
                    </i>
                </div>
            </svelte:fragment>
            {#if !disabled && open && currentOptions.length > 0}
                <div
                    class="optionBox"
                >
                    <ScrollBox
                        width="100%"
                        height={currentOptions.length >= 5
                            ? '235px'
                            : `${currentOptions.length * 47}px`}
                    >
                        <!-- {#if currentOptions.length > 0} -->
                        <List
                            elements={currentOptions}
                            resolveId={(x, i) => {
                                // console.log({x})
                                return x.value
                            }}
                            bind:focusElement
                            render={(e) => e.label}
                            selected={option}
                            on:click={({ detail: { element } }) => {
                                option = element
                                open = false
                                display = option.label
                            }}
                        />
                        <!-- {:else}
            No options
          {/if} -->
                    </ScrollBox>
                </div>
            {/if}
        </PopOver>
    </div>
    <span
        class={!valid && validation && value && !disabled ? 'error' : ''}
        style={`${(!valid && errorMsg && !disabled) || info ? 'padding: 11px 0;' : ''}; ${overline ? `border-top: 1px var(--color-grey-${focus && !disabled ? '800' : '300'}) solid` : ''}`}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
    </span>
</div>

<style>
    .box {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    /* input[type="text"].multi {
    height: 25px;
  } */
    input[type='text'] {
        background: transparent;
        padding: 0 0 11px 5px;
        border-style: none;
        margin: 0;
        font-size: 17px;
        /* width: fit-content; */
        /* line-height: 22px; */
        color: var(--color-black);
        position: relative;
        width: 100%;
        outline: none;
        cursor: pointer;
        box-sizing: border-box;
        caret-color: #5496e3;
        caret-shape: bar;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    span {
        width: 100%;
        display: flex;
        transition: all 0.2s ease-in-out;
    }

    .error {
        border-top: 1px var(--color-accent-alert-error) solid;
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        /* border-top: 1px var(--color-grey-300) solid; */
        cursor: no-drop;
    }

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }

    .optionBox {
        width: 100%;
        position: absolute;
        min-height: 22px;
        max-height: calc(5 * 47px);
        top: calc(100% + 1px);
        background: #ffffff;
        box-shadow:
            0px 2px 4px rgba(0, 0, 0, 0.2),
            0px -1px 1px rgba(0, 0, 0, 0.02);
        z-index: var(--lvl-4);
        overflow-y: scroll;
    }
    .optionBox::-webkit-scrollbar {
        display: none;
    }
</style>
